import { ChainId, Token } from '@mkrman/sdk'
import { CHAIN_ID } from './networks'
import { defineTokens } from './tokens'

const { MAINNET } = ChainId

export const mainnetTokens = defineTokens({
  warn: new Token(MAINNET, '0x15E2d9f6C550f79b3A394F8E53Aa552e097CC40B', 18, 'WARN', 'Test Warning Token', ''),
} as const)

export const testnetTokens = defineTokens({} as const)

const tokens = () => {
  // If testnet - return list comprised of testnetTokens wherever they exist, and mainnetTokens where they don't
  if (parseInt(CHAIN_ID, 10) === ChainId.TESTNET) {
    return Object.keys(mainnetTokens).reduce((accum, key) => {
      return { ...accum, [key]: testnetTokens[key] || mainnetTokens[key] }
    }, {} as typeof testnetTokens & typeof mainnetTokens)
  }

  return mainnetTokens
}

const unserializedTokens = tokens()

export default unserializedTokens
